import { useState } from "react";
import { Link } from "react-router-dom";
import { TowerControl } from "lucide-react";
import api, { formatApiError } from "../lib/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-200 dark:bg-slate-950 flex items-center justify-center p-6">
      <div className="w-full max-w-sm" data-testid="forgot-password-page">
        <div className="flex items-center gap-3 mb-8">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-emerald-50 dark:bg-emerald-500/10 border border-emerald-300 dark:border-emerald-500/40">
            <TowerControl className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
          </div>
          <div className="text-base font-extrabold tracking-tight text-slate-900 dark:text-slate-100">SHD CONTROL TOWER</div>
        </div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-100">Reset password</h1>
        {done ? (
          <div data-testid="forgot-password-confirmation" className="mt-4 rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 px-4 py-3 text-base text-slate-700 dark:text-slate-300">
            If that email is registered, a reset link has been sent.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-password-form">
            {error && (
              <div data-testid="forgot-password-error" className="rounded-md border border-rose-300 dark:border-rose-500/40 bg-rose-50 dark:bg-rose-500/10 px-3 py-2 text-base text-rose-700 dark:text-rose-300">
                {error}
              </div>
            )}
            <div>
              <label className="block text-sm font-mono uppercase tracking-wider text-slate-600 dark:text-slate-400 mb-1.5">Email</label>
              <input
                data-testid="forgot-password-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 py-2.5 text-base text-slate-900 dark:text-slate-100 focus:border-emerald-500 dark:focus:border-emerald-500/60 focus:outline-none"
              />
            </div>
            <button
              data-testid="forgot-password-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full rounded-md bg-emerald-500 px-4 py-2.5 text-base font-bold text-emerald-950 hover:bg-emerald-400 transition-colors disabled:opacity-50"
            >
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <div className="mt-6 text-center">
          <Link data-testid="back-to-signin-link" to="/login" className="text-sm text-slate-600 dark:text-slate-400 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
